import React from 'react';

const Committee = ({ heading, description, people }) => {
  if (people.length === 0) return null;  // Ensure there's at least one person to display

  const [firstPerson, ...restOfPeople] = people;  // Destructure the first person from the array

  return (
    <div className="bg-white py-14">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="flex flex-col items-center lg:flex-row justify-between">
          <div className="lg:w-1/3 text-center">
            <h2 className="text-3xl tracking-tight text-gray-900 sm:text-4xl">
              {heading}
            </h2>
            <p className="mt-4 text-md md:text-lg text-gray-600">
              {description}
            </p>
          </div>
          {/* First person display */}
          <div className="mt-10 lg:mt-0 w-full lg:w-2/3 flex justify-center">
            <div className="flex items-start gap-x-12">
              <img
                alt={firstPerson.name}
                src={firstPerson.imageUrl}
                className="w-20 h-20 object-cover rounded-full"
              />
              <div className="text-center">
                <h3 className="text-lg font-semibold text-gray-900">
                  {firstPerson.name}
                </h3>
                <p className="text-sm font-semibold text-indigo-600">
                  {firstPerson.role}
                </p>
                <p className="text-sm text-gray-600">
                  {firstPerson.designation}
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* List of other people */}
        <ul className="mt-10 grid grid-cols-1 md:grid-cols-2 gap-x-24 gap-y-11">
          {restOfPeople.map((person) => (
            <li key={person.name} className="flex items-start gap-x-6">
              <img
                alt={person.name}
                src={person.imageUrl}
                className="w-20 h-20 object-cover rounded-full"
              />
              <div className="text-center">
                <h3 className="text-lg font-semibold text-gray-900">
                  {person.name}
                </h3>
                <p className="text-sm font-semibold text-indigo-600">
                  {person.role}
                </p>
                <p className="text-sm text-gray-600">
                  {person.designation}
                </p>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default Committee;
